// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getConfigHeaders,
  getConfigBuilder,
  getCartPrice,
  resetConfiguration,
} from '@leasen_nl/listo/src/store/configuration';
import { checkVbmrAvailability } from '@leasen_nl/listo/src/store/vbmr/actions';
import { initVbmr } from '@leasen_nl/listo/src/store/configuration/vbmr/actions';
import Loader from '@leasen_nl/listo/src/components/loader';
import VbmrModal from '@leasen_nl/listo/src/components/config/atoms/vbmrModal';
import {
  getCartHeader,
  getCloseButtonText,
} from '@leasen_nl/listo/src/store/configuratorSettings/selectors';
import type {
  ConfigBuilder,
  ConfigHeaders,
  ConfigHeader,
} from '@leasen_nl/listo/src/store/configuration/configBuilder/types';
import ProgressRow from '@leasen_nl/listo/src/components/progressRow';
import { selectDefaultConfiguration, selectConfigFromUrl } from '@leasen_nl/listo/src/store/configuration/actives';
import { breakpointsToArray } from '@leasen_nl/listo/src/helpers';
import { Container, Flex, Box } from '@leasen_nl/listo/src/components/grid';
import drawerColumn from '@leasen_nl/listo/src/components/drawerColumn/drawerColumn.container';
import ConfigBuilderGroup from '@leasen_nl/listo/src/components/configBuilderGroup';
import { addCriteoBasketPage } from '@leasen_nl/listo/src/store/gtm';
import Cart from '../../../cart';
import { Actions, ConfFormRow } from './atoms';

type StateProps = {|
  cartHeader: string,
  closeButtonText: string,
  configBuilder: ConfigBuilder,
  configHeaders: ConfigHeaders,
  cartPrice: number,
|};

type DispatchProps = {|
  checkVbmr: Function,
  reset: Function,
  configFromUrl: Function,
  selectDefaultConfig: Function,
  addCriteoBasket: Function,
|};

type Props = {|
  ...StateProps,
  ...DispatchProps,
|};

type NativeState = {
  vbmrCheckCompleted: boolean,
};

const cartDimensions = {
  default: 12 / 12,
  md: 4 / 12,
};

const CartColumn = drawerColumn('cartColumn');

class PdbConfig extends Component<Props, NativeState> {
  constructor() {
    super();

    this.state = {
      vbmrCheckCompleted: false,
    };
  }

  componentDidMount() {
    const {
      reset, selectDefaultConfig, configFromUrl, addCriteoBasket, checkVbmr,
    } = this.props;
    reset();
    selectDefaultConfig();
    configFromUrl();
    addCriteoBasket();
    checkVbmr(() => {
      this.setState({
        vbmrCheckCompleted: true,
      });
    });
  }

  render() {
    const {
      cartPrice,
      configBuilder,
      configHeaders,
      cartHeader,
      closeButtonText,
    } = this.props;

    const { vbmrCheckCompleted } = this.state;

    const steps = configHeaders.map((header: ConfigHeader) => ({
      label: header.header,
      id: header.id,
    }));

    return (
      <div className="pdb-config">
        <VbmrModal />
        <ProgressRow
          price={cartPrice}
          steps={steps}
        />
        <ConfFormRow>
          <Container>
            <Flex width={1} wrap>
              <Box
                px={1}
                width={breakpointsToArray({
                  default: 12 / 12,
                  lg: 8 / 12,
                })}
              >
                {!vbmrCheckCompleted
                  // Because of Flow compatibility bug in CP: $Diff<OmitDispatch<ElementConfig<Com>>
                  // $FlowFixMe
                  && <Loader alwaysLoading />}
                {vbmrCheckCompleted
                  && (
                    <>
                      {configBuilder && configBuilder.map((configBuilderGroup, step) => (
                        <ConfigBuilderGroup
                          step={step}
                          group={configBuilderGroup}
                          key={configBuilderGroup.id}
                        />
                      ))}
                      {configBuilder && <Actions />}
                    </>
                  )}
              </Box>
              <CartColumn
                position="right"
                width={4 / 12}
                title={cartHeader}
                closeText={closeButtonText}
                sticky
              >
                <Cart
                  dimensions={cartDimensions}
                />
              </CartColumn>
            </Flex>
          </Container>
        </ConfFormRow>
      </div>
    );
  }
}

const mapStateToProps = (state: any): StateProps => ({
  configBuilder: getConfigBuilder(state),
  configHeaders: getConfigHeaders(state),
  cartHeader: getCartHeader(state),
  closeButtonText: getCloseButtonText(state),
  cartPrice: getCartPrice(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  checkVbmr: (callback: Function) => dispatch(checkVbmrAvailability(() => {
    dispatch(initVbmr());
    callback();
  })),
  selectDefaultConfig: () => dispatch(selectDefaultConfiguration()),
  reset: () => dispatch(resetConfiguration()),
  configFromUrl: () => dispatch(selectConfigFromUrl()),
  addCriteoBasket: () => dispatch(addCriteoBasketPage()),
});

export default connect<Props, any, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(PdbConfig);
